import { FC } from 'react'
import { Navigate, RouteObject, useParams } from 'react-router-dom'
import pathToRegexp from 'path-to-regexp'

import { CustomRedirectOptions } from '~/apps/routes/RoutesTypes'

/**
 * Component to replace old router v5 <Redirect> component
 * renders react-router v6 <Navigate /> with "to" path
 * @param to - path where to redirect user
 * @param redirectWithParams - if we need to keep route params while redirecting
 * @constructor
 */
const Redirect: FC<{ to: string; redirectWithParams?: boolean }> = ({
    to,
    redirectWithParams = false,
}) => {
    const params = useParams()
    let finalRedirectTo = to

    if (redirectWithParams) {
        const pathTo = pathToRegexp.compile(to)

        finalRedirectTo = pathTo(params)
    }

    return <Navigate to={finalRedirectTo} replace />
}

/**
 * Function which maps our custom redirect configs {CustomRedirectOptions} to react-router config
 * @param redirects
 */
export const mapRedirectsToReactRouter = (
    redirects: CustomRedirectOptions[],
): RouteObject[] => {
    return redirects.flatMap(
        ({ path: incomingPath, redirectTo, redirectWithParams }) => {
            const paths: string[] =
                typeof incomingPath === 'string' ? [incomingPath] : incomingPath

            return paths.map(path => {
                return {
                    path,
                    element: (
                        <Redirect
                            to={redirectTo}
                            redirectWithParams={redirectWithParams}
                        />
                    ),
                }
            })
        },
    )
}
